import { checkDateStringFormat } from './check-date-string-format';

function isLeapYear(year: number): boolean {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

/* eslint-disable complexity */
export const isValidDate = (dateString: string): boolean => {
  if (!dateString) return false;
  if (!checkDateStringFormat(dateString)) return false;

  const [dayStr, monthStr, yearStr] = dateString.split('.');
  if (!dayStr || !monthStr || !yearStr) return false;

  const day = parseInt(dayStr, 10);
  const month = parseInt(monthStr, 10);
  const year = parseInt(yearStr, 10);

  if (Number.isNaN(day) || Number.isNaN(month) || Number.isNaN(year)) return false;
  if (year < 1900 || year > 9999) return false;
  if (month < 1 || month > 12) return false;

  const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (isLeapYear(year)) daysInMonth[1] = 29;

  if (day < 1 || day > daysInMonth[month - 1]) return false;

  return true;
};
